import type { FinanceRate } from '@kanda-libs/ks-frontend-services';

export interface FinanceCosts {
  creditLine: number;
  fee: number;
  monthly: number;
}

export const calculateFinanceCosts = (
  option: FinanceRate,
  credit: number,
): FinanceCosts => {
  const interest = (option?.apr || 0) / 100;
  const duration = option?.duration || 1;
  const rate = interest / 12 / 100;
  const compoundInterest = (1 + rate) ** duration;
  const monthlyLoan = Math.ceil(
    (credit * (rate * compoundInterest)) / (compoundInterest - 1),
  );
  const cost = Math.ceil(monthlyLoan * duration);
  return {
    creditLine: credit,
    fee: cost - credit,
    monthly: monthlyLoan,
  };
};
